import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import Logger from 'observability/Logger';

const LOG = new Logger('Date-utils');
const DATE_DISPLAY_FORMAT = 'dd MMMM yyyy';
export const LABEL_DATE_TBD = 'Date TBD';

/**
 * Transforms a pair of dates to a human readable format. This function can be
 * called with 2 dates, only 1 date or no dates at all.
 * @param eventStart An ISO 8601 formatted date
 * @param eventEnd An ISO 8601 formatted date
 * @see {@link http://en.wikipedia.org/wiki/ISO_8601}
 * @returns
 *  {{formattedStart: string | *}|{formattedEnd: string | *, formattedStart: string | *}|{formattedStart: string}}
 *  If both dates are passed, and the dates are in different days, the
 *  transformed dates will be returned in a single object containing
 *  `formattedStart` and `formattedEnd` properties. In case 2 dates are passed
 *  but both represent the same day, only the `formattedStart` will be returned.
 *  If only one date is passed, the returning object will only have the
 *  `formattedStart` property on it. In case this function is called without
 *  dates (or with invalid dates) the function will return an object containing
 *  only `formattedStart`, whose value will be a placeholder: 'Date TBD'.
 */
export const formatEventDate = (eventStart, eventEnd) => {
    if (!eventStart) {
        return { formattedStart: LABEL_DATE_TBD };
    }

    let formattedEventStartDate;
    const eventStartObject = parseISO(eventStart);
    try {
        formattedEventStartDate = format(eventStartObject, DATE_DISPLAY_FORMAT);
        const eventEndObject = parseISO(eventEnd);
        const isSingleDay = isSameDay(eventStartObject, eventEndObject);

        if (!eventEnd || isSingleDay) {
            return { formattedStart: formattedEventStartDate };
        }

        const formattedEventEndDate = format(eventEndObject, DATE_DISPLAY_FORMAT);
        // If the end time is on a different day
        return {
            formattedStart: formattedEventStartDate,
            formattedEnd: formattedEventEndDate,
        };
    } catch (e) {
        LOG.warn('Exception captured in formatEventDate:', e);
        return {
            formattedStart: formattedEventStartDate || LABEL_DATE_TBD,
        };
    }
};
